import { HStack } from '@chakra-ui/react';
import { Checkbox, CheckboxProps } from '@components/ui/checkbox/Checkbox';
import { Field, FieldInputProps, FormikProps } from 'formik';
import { PropsWithChildren } from 'react';

export function FormCheckbox<T>({ children, ...props }: PropsWithChildren<CheckboxProps>) {
  return (
    <Field name={props.name} type="checkbox">
      {({ field, form }: { field: FieldInputProps<string>; form: FormikProps<T> }) => (
        <HStack gap={1}>
          <Checkbox
            {...field}
            {...props}
            checked={field.checked}
            onChange={(event) => form.setFieldValue(field.name, (event.target as HTMLInputElement).checked)}
          >
            {children}
          </Checkbox>
        </HStack>
      )}
    </Field>
  );
}
